import PickerMenu from './at_picker_menu'
import DatePicker from './at_date_picker'
import SpecialMenuMgr from '../at_specialMenuMgr'
import Ext from 'Ext'

Ext.namespace('AT.menu');

const DatePickerMenu = Ext.extend(PickerMenu, {
    cancelOnHide: false,

    constructor : function(config)
    {
        var picker = new DatePicker( config );

        DatePickerMenu.superclass.constructor.call(this, config, picker);

        /*
         * @event datePickerUpdate
         * Fires when the contents of the date picker are updated, e.g. when the cursor is moved or month is changed,
         * but the selection is not submitted (the date picker remains visible).
         * Fires only in 'dynamic' mode ({@see AT.menu.DatePickerMenu#mode} )
         * @param {Date} date The currently selected date
         */
        this.addEvents('datePickerUpdate');

        /**
         * @event datePickerCancel
         * Fires when the user cancels the date selection.
         */
        this.addEvents('datePickerCancel');

        this.on('beforeshow', function()
        {
            if (this.picker)
            {
                this.picker.useUpdateEvent = this.isDynamicMode();
            }
        }, this);

        this.on('beforehide', function()
        {
            if (this.isDynamicMode())
            {
                if (this.cancelOnHide || SpecialMenuMgr.wasEscKeyDown())
                {
                    // behave as if the cancel event came from date picker
                    if (this.picker)
                        this.picker.cancel();
                }
                else
                {
                    // Apply date selection on hide, but only if it wasn't applied yet.
                    if (!this.selectionFinished && this.picker)
                    {
                        this.wasSelectionOnHide = true;
                        this.picker.selectActiveDate();
                    }
                }
            }
        }, this);

        this.picker.on("update", this.onDatePickerUpdate, this);
        this.picker.on("cancel", this.onDatePickerCancel, this);
        this.picker.on("clear", this.onDatePickerClear, this);
    }});

Ext.extend(DatePickerMenu, PickerMenu,
{
   mode : 'static',

   /**
    * True if the date selection was applied on date picker hide (if user clicked outside).
    * False if the the selection wasn't applied since the date picker was shown for the last time,
    * or it was applied explicitly (by clicking on a day, by clicking an OK button, or by pressing Enter).
    */
   wasSelectionOnHide : false,

   /**
    * In 'dynamic' mode the menu fires the "datePickerUpdate" event when user moves around in the date picker,
    * and the date selection is automatically applied when the date picker is closed (except for the Cancel button and
    * the Esc key).
    *
    * In 'static' mode the menu doesn't fire the "datePickerUpdate" event and the date selection is only applied when
    * the user clicks OK or presses Enter or clicks on a day.
    */
   isDynamicMode : function()
   {
       return this.mode == 'dynamic';
   },

   show : function(el, pos, parentMenu, mode)
   {
       if( mode )
           this.mode = mode;
       this.wasSelectionOnHide = false;
       DatePickerMenu.superclass.show.call(this, el, pos, parentMenu);
   },

   onDatePickerUpdate : function(picker, date)
   {
       this.fireEvent("datePickerUpdate", date);
   },

   onDatePickerCancel : function()
   {
       this.selectionFinished = true;
       this.hide();
       this.fireEvent("datePickerCancel");
   },

   onDatePickerClear: function()
   {
       this.selectionFinished = true;
       this.hide();
       this.fireEvent("datePickerClear");
   }
});

export default DatePickerMenu



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_date_picker_menu.js